export const PXHero = (function () {
	'use strict';

	function init() {
		// Hacky way to get the home hero to behave
		document.querySelectorAll('.pxblock--hero').forEach((heroBlock) => {
			const siblingArrowButton = heroBlock.querySelector('.btn + .btn-arrow');

			if (siblingArrowButton) siblingArrowButton.parentNode.classList.add('flex-row-center');
		});
	}

	return {
		init: init,
	};
})();
